import React from 'react';
import { Button, Table, Checkbox, Pagination, Row, Col, DropdownButton, MenuItem, Navbar, FormGroup, FormControl } from 'react-bootstrap';

export default class DataTable extends React.Component {

  constructor(props) {
    super(props);

    this.handleChangeActivepage = this.handleChangeActivepage.bind(this);
    this.handleChangeItemPerPage = this.handleChangeItemPerPage.bind(this);

    this.checkBoxMap = new Map();
    this.searchInput = '';
  }

  componentDidMount() {
    if (this.props.refresh) {
      this.props.refresh({ activePage: this.props.activePage, itemPerPage: this.props.itemPerPage });
    }
  }

  //   componentWillUnmount() {
  //   }

  handleAdd() {
    this.props.openAddModal();
  }

  handleEdit(pk) {
    this.props.handleEdit(pk);
  }

  handleEdit1(pk) {
      this.props.handleEdit1(pk);
  }

  handleEdit2(pk) {
      this.props.handleEdit2(pk);
  }

  handleDelete() {
    let r = confirm('確認刪除 ?');
    if (r === true) {
      let deleteKey = [];
      for (let key of this.checkBoxMap.keys()) {
        if (this.checkBoxMap.get(key)) {
          if (this.checkBoxMap.get(key).checked) {
            deleteKey.push(key);
          }
        }
      }
      this.props.deleteItems(deleteKey, { activePage: this.props.activePage, itemPerPage: this.props.itemPerPage });
    }
  }

  handleChangeActivepage(eventKey) {
    if (this.props.changeActivepage) {
      this.props.changeActivepage({
        activePage: eventKey,
        itemPerPage: this.props.itemPerPage
      }, {
          searchKeys: this.props.searchKeys,
          searchWord: this.props.searchWord
        });
    }
  }

  handleSearch(searchWord) {
    // console.log(searchWord);
    if (this.props.searchKeys) {
      this.props.search({
        activePage: 1,
        itemPerPage: this.props.itemPerPage
      }, {
          searchKeys: this.props.searchKeys,
          searchWord: searchWord
        });
    }
  }

  handleChangeItemPerPage(event) {
    if (this.props.changeActivepage) {
      this.props.changeActivepage({
        activePage: 1,
        itemPerPage: event.target.value
      }, this.props.filter);
    }
  }

  render() {

    // let refreshBtn = null;
    // if (this.props.refresh) {
    //   refreshBtn = (<Col xs={2} sm={1} md={1}><Button onClick={this.props.refresh}>Refresh</Button></Col>);
    // }

    let deleteBtn = (
      <div style={{ paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}>
        <Button bsStyle="default" onClick={(event) => {
          this.handleDelete();
        }}>
          <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
          <span style={{ color: '#a94442' }}>Delete</span>
        </Button>
      </div>);

    let addBtn = (
      <Col xs={2} sm={1} md={1}>
        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          <Button bsStyle="default" onClick={(event) => {
            this.handleAdd();
          }}>
            <span className="glyphicon glyphicon-plus" style={{ marginRight: 10 }} />Add
          </Button>
        </div>
      </Col>);
    if (this.props.disableAdd) {
      addBtn = null;
    }

    let searchBar = null;
    let searchPlaceholder = 'Search';
    if (this.props.searchPlaceholder) {
      searchPlaceholder = this.props.searchPlaceholder;
    }
    if (this.props.searchKeys) {
      searchBar = (
        <Col xsPush={10} smPush={11} mdPush={11}>
          <div style={{ textAlign: 'right' }}>
            <Navbar.Form>
              <FormGroup>
                <FormControl type="text" placeholder={searchPlaceholder} inputRef={ref => { this.searchInput = ref; }}
                  onKeyDown={(event) => {
                    // keyCode = 13 => eneter 鍵
                    if (event.keyCode === 13) {
                      this.handleSearch(this.searchInput.value);
                    }
                  }}
                  tabIndex="1" />
              </FormGroup>
              <span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }}
                onClick={(event) => {
                  this.handleSearch(this.searchInput.value);
                }} tabIndex="2" />
            </Navbar.Form>
          </div>
        </Col>);
    }

    let tableHeader = [];
    if (this.props.showCheckBox) {
      if (!this.props.disableEdit) {
        tableHeader.push((
          <th key='checkBoxes' colSpan={2} style={{ width: 1 }}>{deleteBtn}</th>
        ));
      }
      else {
        tableHeader.push((
          <th key='checkBoxes' style={{ width: 1 }}>{deleteBtn}</th>
        ));
      }
    } else {
      if (!this.props.disableEdit) {
        tableHeader.push((
          <th key='moreTd' style={{ width: 1 }}></th>
        ));
      } else {
      }
    }

    for (let fieldName in this.props.fields) {
      if (this.props.fields.hasOwnProperty(fieldName)) {
        tableHeader.push((
          <th key={fieldName} style={{ verticalAlign: 'middle' }}>{this.props.fields[fieldName]}</th>
        ));
      }
    }

    let tableRows = [];
    if (this.props.data) {
      //for (let i in this.props.data) {
      for (let i = 0; i < this.props.data.size; i++) {
        //let row = this.props.data[i];
        let row = this.props.data.get(i);
        let pkStr = i;  // default key
        // primary key object
        let pk = {};
        if (this.props.keys) {
          for (let i = 0; i < this.props.keys.length; i++) {
            let keyField = this.props.keys[i];
            //pk[keyField] = row[keyField];
            pk[keyField] = row.get(keyField);
          }
          // primary key as a string
          pkStr = JSON.stringify(pk);
        }

        let editBtn = null;
        let defaultEditClassName = "glyphicon glyphicon-pencil";
        let defaultEditShowText = "Edit";
        if (this.props.edit0) {
          defaultEditClassName = this.props.edit0.className;
          defaultEditShowText = this.props.edit0.showText;
        }
        // edit button 兩個以上
        if (this.props.showEditMore) {
          let dropdownBtn0 = null;
          let dropdownBtn1 = null;
          let dropdownBtn2 = null;

          if (!this.props.hideEditActions) {
            dropdownBtn0 = (<MenuItem eventKey="0" onClick={(event) => {
              this.handleEdit(pk);
            }}><span className={defaultEditClassName} style={{ marginRight: 10 }} />{defaultEditShowText} </MenuItem>);
          }
          if (this.props.edit1 && !this.props.hideEditActions) {
            dropdownBtn1 = (<MenuItem eventKey="1" onClick={(event) => {
              this.handleEdit1(pk);
            }}><span className={this.props.edit1.className} style={{ marginRight: 10 }} />{this.props.edit1.showText} </MenuItem>);
          }
          if (this.props.edit2) {
            dropdownBtn2 = (<MenuItem eventKey="2" onClick={(event) => {
              this.handleEdit2(pk);
            }}><span className={this.props.edit2.className} style={{ marginRight: 10 }} />{this.props.edit2.showText} </MenuItem>);
          }

          editBtn = (
            <DropdownButton title="More" id="moreBtn">
              {dropdownBtn0}
              {dropdownBtn1}
              {dropdownBtn2}
            </DropdownButton>
          );
        }
        // edit button 只有一個 
        else {
          editBtn = (
            <Button bsStyle="default" onClick={(event) => {
              this.handleEdit(pk);
            }}><span className={defaultEditClassName} style={{ marginRight: 10 }} />{defaultEditShowText}</Button>
          );
        }

        let rowObj = [];
        if (this.props.showCheckBox) {
          rowObj.push((
            <td key='checkBoxes' style={{ textAlign: 'center', width: 1 }}><Checkbox inline inputRef={(ref) => this.checkBoxMap.set(pk, ref)} /></td>
          ));
        }
        if (!this.props.disableEdit) {
          rowObj.push((
            <td key='edits' style={{ width: 1 }}>
              {editBtn}
            </td>
          ));
        }
        for (let fieldName in this.props.fields) {
          if (this.props.fields.hasOwnProperty(fieldName)) {
            rowObj.push((
              <td key={fieldName}>{row.get(fieldName)}</td>
            ));
          }
        }

        tableRows.push((
          <tr key={pkStr} onClick={
            (event) => {
              if (this.props.onClick) {
                //                this.props.onClick(pk);
              }
            }
          }>
            {rowObj}
          </tr>
        ));
      }
    }

    let paging = null;
    paging = (
      <Row>
        <Col xs={3} sm={3}>
          <div className="form-inline">
            <label>每頁筆數:&nbsp;&nbsp;</label>
            <select className="form-control" id="foo" style={{ width: 65 }} onChange={this.handleChangeItemPerPage}>
              <option value={10} selected={this.props.itemPerPage === 10}>10</option>
              <option value={50} selected={this.props.itemPerPage === 50}>50</option>
            </select>
          </div>
        </Col>
        <Col xs={9} sm={9}>
          <div style={{ textAlign: 'right', marginTop: -20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              items={this.props.totalPage}
              maxButtons={this.props.pagingMaxButtons}
              activePage={this.props.activePage}
              onSelect={this.handleChangeActivepage} />
          </div>
        </Col>
      </Row>
    );

    if (this.props.hidePaging) {
      paging = null;
    }

    let overflowStyle = {
      width: '100%'
    };

    return (
      <div style={overflowStyle}>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          {addBtn}{searchBar}
        </Row>
        <Table bordered condensed hover striped>
          <thead>
            <tr>
              {tableHeader}
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </Table>
        {paging}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DataTable.jsx